//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "WidgetAdmin",

  props:{
    baseApiUrl:{
      type:String,
      default:'',
    }
  },

  fetch(){
    this.currentCookies = this.$cookies.get('_adminIdentity');

  },

  data(){
    return{
      linkList: {
        cmsPage: {mainLink:'/admin#!/template/cmsadmin~2Fdefault~2Findex/update/'},
        product:{ mainLink:'/admin#!/default/9/shopadmin/products/index/'},
        category:{mainLink: '/admin#!/default/9/shopadmin/categories/index/'}
      },

      currentCookies:null,
    }
  },

  computed:{
    adminLink: function () {
      const product = Boolean(!!this.currentProduct );
      const category = Boolean(!!this.currentCategory );
      const cmsPage = Boolean(!!this.currentCmsPage && !category && !product);

      if (!!cmsPage) return this.currentCmsPage;

      if (!!category) return this.currentCategory;

      if(!!product) return this.currentProduct;

      return '';
    },

    currentCmsPage(){
      const currentPage = this.$store.getters['cms/page'] || null;

      if(!!currentPage){
          return this.gatherLink({
            id: currentPage?.page?.navId || currentPage?.page?.id,
            link:this.linkList.cmsPage.mainLink,
          })
      }

      return null;
    },

    currentCategory(){
      const currentCategory = this.$store.getters['catalog/currentCategory'] || null;

      if(!!currentCategory && this.$route?.params?.pathMatch === currentCategory.slug){
        return this.gatherLink({
          id: currentCategory?.id,
          link: this.linkList.category.mainLink,
        })
      }

      return  null;
    },

    currentProduct(){
      const currentProduct = this.$store.getters['products/currentProduct'] || null;

      if(!!currentProduct && this.$route?.params?.slug === currentProduct.slug){
        return this.gatherLink({
          id: currentProduct?.id,
          link: this.linkList.product.mainLink,
        })
      }

      return  null;
    },
  },

  methods:{
    gatherLink(props){
      const {link, id} = props;
      const baseApiUrl = this.baseApiUrl;

      return `${baseApiUrl}${link}${id}`;
    },
  },
}
